import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {DataService} from '../../services/data.service';

@Component({
  selector: 'app-layout-sort',
  templateUrl: './layout-sort.component.html',
  styles: [
  ]
})
export class LayoutSortComponent  extends ExcTranslation implements OnInit {
  @Input()
  uiSort: any[] = [];

  constructor(
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    private dataSvc: DataService
  ) {
    super();
  }

  ngOnInit(): void {
  }

}
